import React, { useState } from "react";
import CourseCreation from "../components/Programs/CourseCreation/CourseCreation";
import Aside from "../modules/SideNav/Aside";

export default function CourseCreationLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <CourseCreation handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}
